<template>
  <div class="field-hubscreen container" :data-sectionid="data.Id">
    <h2 v-if="data.Text"><Localize :text="data.Text" /></h2>
    <i v-if="data.Description">
      <Localize :text="data.Description" />
    </i>
    <template v-if="data.Body.length > 0">
      <div class="field-hubscreen-body">
        <div class="field-hubscreen-body-section" v-for="(field, index) in data.Body" :key="'hubsection_' + index">
          <legend>
            <Localize :text="field.Text" />
          </legend>
          <BorrowerList :icon="field.Fields[0][0].Icon" :targetid="field.Fields[0][0].Target" :description="field.Fields[0][0].Description" :listtype="data.HubType" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'

import BorrowerList from '@/components/BorrowerList.vue'
import Localize from '@/components/Localize.vue'

export default {
  name: 'FieldHubScreen',
  components: { 
    BorrowerList,
    Localize
  },
  props: {
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String
  },
  data: () => {
    return {
      PreApproveMe
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.field-hubscreen {
  padding-bottom: 40px;
  &.container {
    width: $screen-container-width;
  }
  .field-hubscreen-body {
    &.form {
      .field-wrapper {
        border-top: solid 1px $grid-form-border-color;
        &:last-child {
          border-bottom: solid 1px $grid-form-border-color;
        }
      }
    }
  }
}
</style>
